var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { alignItems, fontSize, justifyContent } from 'styled-system';
import PropTypes from 'prop-types';
import { Banner } from '../Banner';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { Link } from '../Link';
import { Relative } from '../Relative';
import { Button } from '../Button';
var BannerWithRadius = styled(Banner)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n"], ["\n  cursor: ", ";\n"])), function (props) { return (props.onClick ? 'pointer' : 'cursor'); });
var WrapperLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: 1;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"], ["\n  z-index: 1;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"])));
var CustomLink = styled(Link)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  z-index: 2;\n"], ["\n  display: inline-flex;\n  z-index: 2;\n"])));
var CustomButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  z-index: 2;\n  text-decoration: ", ";\n"], ["\n  z-index: 2;\n  text-decoration: ", ";\n"])), function (props) { return (props.buttonTextUnderline ? 'underline' : 'none'); });
var propTypes = __assign(__assign(__assign(__assign({}, alignItems.propTypes), justifyContent.propTypes), fontSize.propTypes), { buttonClick: PropTypes.func, buttonSize: PropTypes.oneOf(['small', 'medium', 'large']), buttonVariation: PropTypes.oneOf(['fill', 'outline', 'link']), ctaText: PropTypes.node, heading: PropTypes.node, iconLeft: PropTypes.node, iconRight: PropTypes.node, imageLeft: PropTypes.node, linkVariation: PropTypes.oneOf(['fill', 'outline', 'link']), linkColor: PropTypes.string, text: PropTypes.node, URLProps: PropTypes.shape({
        href: PropTypes.string.isRequired,
        target: PropTypes.string,
    }), urlText: PropTypes.string });
var GenericBanner = function (_a) {
    var alignItems = _a.alignItems, buttonClick = _a.buttonClick, buttonSize = _a.buttonSize, buttonVariation = _a.buttonVariation, ctaText = _a.ctaText, fontSize = _a.fontSize, heading = _a.heading, iconLeft = _a.iconLeft, iconRight = _a.iconRight, imageLeft = _a.imageLeft, justifyContent = _a.justifyContent, linkVariation = _a.linkVariation, linkColor = _a.linkColor, text = _a.text, 
    /* eslint-disable @typescript-eslint/naming-convention */
    URLProps = _a.URLProps, props = __rest(_a, ["alignItems", "buttonClick", "buttonSize", "buttonVariation", "ctaText", "fontSize", "heading", "iconLeft", "iconRight", "imageLeft", "justifyContent", "linkVariation", "linkColor", "text", "URLProps"]);
    function onClick(e) {
        e.stopPropagation();
        buttonClick();
    }
    return (React.createElement(Relative, null,
        URLProps && React.createElement(WrapperLink, __assign({ tabIndex: -1, "aria-hidden": 'true' }, URLProps)),
        React.createElement(BannerWithRadius, __assign({}, props, { onClick: URLProps ? null : buttonClick }),
            React.createElement(Flex, { alignItems: alignItems, justifyContent: justifyContent },
                !!iconLeft && iconLeft,
                !!imageLeft && imageLeft,
                React.createElement(Box, { px: 2, fontSize: fontSize },
                    !!heading &&
                        React.cloneElement(heading, {
                            fontSize: heading.props.fontSize || fontSize,
                        }),
                    !!text &&
                        React.cloneElement(text, {
                            fontSize: fontSize,
                        }),
                    URLProps && ctaText && (React.createElement(CustomLink, __assign({ p: linkVariation === 'fill' || linkVariation === 'outline' ? 2 : null, color: linkColor, variation: linkVariation, fontSize: fontSize }, URLProps), React.cloneElement(ctaText, {
                        fontSize: fontSize,
                        zIndex: 2,
                    }))),
                    buttonClick && typeof buttonClick === 'function' && ctaText && (React.createElement(CustomButton, { size: buttonSize, buttonTextUnderline: buttonVariation === 'link', variation: buttonVariation, onClick: onClick }, React.cloneElement(ctaText, {
                        fontSize: fontSize,
                    })))),
                !!iconRight && iconRight))));
};
GenericBanner.propTypes = propTypes;
GenericBanner.defaultProps = {
    alignItems: 'center',
    buttonVariation: 'link',
    fontSize: [0, null, null, 1],
    justifyContent: 'center',
    linkColor: 'primary',
    linkVariation: 'link',
    borderRadius: '6px',
};
export default GenericBanner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=GenericBanner.js.map